import "./assets/main.css";
import "./assets/sass/style.scss";
// @ts-ignore
import { createApp, ref } from "vue";
import App from "./App.vue";
import router from "./router";
import validators from "./validator/index";
import DateMonthYearFormatDirective from "./service/DateMonthFormatDirective";
import { getDeviceType } from "./interface/deviceDetect";
import "./assets/scss/global.scss";
import "./assets/scss/progressBar.scss";
import { setConfig } from "./constants/constants";
import axios from "axios";
import "../src/service/axiosConfig";
import { initPortalEncryptionSettings } from "./utils/request";

validators();
const app = createApp(App);

const deviceType = ref(getDeviceType());
app.provide("deviceType", deviceType);

app.use(router);
app.directive("dateFormat", DateMonthYearFormatDirective);

// const env = import.meta.env.VITE_NODE_ENV;

async function loadAndInitConfig() {
  const mode = import.meta.env.MODE;

  const envFileMap: Record<string, string> = {
    dev: "/cc-onboard/config-dev.json",
    iit: "/cc-onboard/config-iit.json",
    sit: "/cc-onboard/config-sit.json",
    uat: "/cc-onboard/config-uat.json",
    prod: "/cc-onboard/config-prod.json",
  };

  let response;

  // 1. Priority: use MODE if it's dev, iit, etc.
  if (mode && envFileMap[mode]) {
    response = await axios.get(envFileMap[mode]);
  } else {
    // 2. Fallback: get config.json and decide based on its value
    const initial = await axios.get("/cc-onboard/config.json");
    const env = initial.data?.VITE_NODE_ENV;

    if (env && envFileMap[env]) {
      response = await axios.get(envFileMap[env]);
    } else {
      response = initial; // fallback to original config if no match
    }
  }

  const config = response.data;
  setConfig(config); // Save config globally
  axios.defaults.baseURL = config.VITE_APP_ROOT_API;
  initPortalEncryptionSettings();
  app.mount("#app");
}

loadAndInitConfig();

export { app };
